<template>
  <div>
    <popup :message="alertErrMessage" v-if="isAlertErr" @close="isAlertErr = false" />
    <div class="banner">
      <img :src="classDetail.image_url" class="img-banner" />
      <div class="body-banner">

        <div class="label-list">
          <div v-for="(tag, index) in $t('bootcampDetail.heroSection.tags')" :key="index"
            class="btn-white-alice font-poppins">
            {{ tag }}
          </div>
        </div>
        <h2 class="title-banner">
          {{ classDetail.name }}
        </h2>
        <p class="sub-title-banner">{{ $t('bootcampDetail.heroSection.subHeading') }}</p>
        <div class="mb-10">
            <span style="font-size:12px;color: #7B7E8C;">Didukung sertifikasi global</span>
            <div class="d-flex align-center">
                <img src="/img/bootcamp/aca.png" alt="" style="width: 48px; border-radius: 16px;">
                <span class="ml-3">Alibaba Cloud Associate (ACA) Developer</span>
            </div>
        </div>
        <button class="button-daftar" @click="goToCheckoutPage('register')">
          {{ $t('bootcampDetail.heroSection.ctaButtons.registerNow') }}
        </button>
      </div>
    </div>
    <div>
      <div class="container" style="margin-top: 30px;">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500; line-height: 28px;">{{
          $t('bootcampDetail.sections.overview.subtitle') }}</span>
        <h5 class="title mb-4"
          style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px">{{
            $t('bootcampDetail.sections.overview.title') }} </h5>
        <p class="mt-5" style="text-align: justify;color: #575966; font-size: 13px;" v-html=" $t('bootcampDetail.sections.overview.desc')"></p>
      </div>

      <div class="container">
        <span class="addional">{{ $t('bootcampDetail.sections.curriculum.title') }}</span>
        <h5 class="title" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('bootcampDetail.sections.curriculum.subtitle') }}
        </h5>

        <div class="card-phase">
            <div class="d-flex align-center mt-5" v-for="(i, phase) in curriculums" :key="phase">
                <v-btn outlined style="border-radius: 40px;" class="btn-oval-with-width mr-2" @click="getCurriculum(i.id - 1)" :class="{ 'bg-full-active': curriculumActive === i.id }">
                    Fase {{ i.id }}
                </v-btn>
            <div v-if="i.id != '4'" style="height: 1px;width: 20px; background-color: #36373F;"></div>
            </div>
        </div>

        <div class="timeline-bootcamp mt-5 pa-5">
            <h5>Bootcamp Fase {{ this.tempCurriculums.id }}</h5>
            <h3 class="mt-2">{{ this.tempCurriculums.title }}</h3>
            <p class="mt-2" v-html="tempCurriculums.desc"></p>

            <h4 class="mt-7 mb-3">Materi yang akan dipelajari</h4>
            <div style="color: #36373F;">
            <div class="d-flex align-center" style="background-color: #FFDE59;height: 40px;color: #36373F;font-weight: 600;border-top-left-radius: 8px; border-top-right-radius: 8px;">
                <img src="/img/bootcamp/ic_hardskill.png" width="24" class="ml-3"/>
                <span class="ml-3">Hardskill</span>
            </div>
            <div style="background-color: white;" class="pl-3 pt-5 pb-5 pr-3">
                <ul>
                <li v-for="(i, list) in tempCurriculums.material.categories[0].detail" :key="list">
                    <span style="font-weight: 700;">{{ i.title }}</span> <br> <p v-html="i.desc"></p>
                </li>
                </ul>
            </div>

            <div class="d-flex align-center mt-5" style="background-color: #FFDE59;height: 40px;color: #36373F;font-weight: 600;border-top-left-radius: 8px; border-top-right-radius: 8px;">
                <img src="/img/bootcamp/ic_softskill.png" width="24" class="ml-3"/>
                <span class="ml-3">Softskill</span>
            </div>

            <div style="background-color: white;" class="pl-3 pt-5 pb-5 pr-3">
                <p v-html="this.tempCurriculums.material.categories[1].detail[0].desc"></p>
            </div>
            </div>

            <h4 class="mt-7 mb-3">Tools Yang digunakan</h4>
            <div class="d-flex align-center">
            <div class="mr-3 align-center d-flex" v-for="(i, image) in tempCurriculums.tools" :key="image" style="background: white;width: 120px;height: 56px;">
                <div style="margin: auto;"><img :src="$utils.loadImage(i.img)" width="28"/></div>
            </div>
            </div>
        </div>
      </div>

        <div class="container" style="margin-top: -60px;">
            <div class="pa-5" style="background-color: #FFDE59;border-radius: 8px;font-size: 13px;">
                <div>
                    <span>Pelajari informasi lebih lengkap dengan dapatkan</span> <span style="color: #162CA2;font-weight: 700;">silabus Fullstack Web Development with AI Integration.</span>
                </div>
                <v-btn depressed color="#162CA2" class="box-cta-daftar mt-5" @click="goToCheckoutPage('syllabus')">
                    <span class="text-capitalize white--text" style="font-size: 14px; letter-spacing: 0 !important;font-weight: 600;">
                        UNDUH SILABUS
                    </span>
                </v-btn>
            </div>
        </div>
      
      <div class="container">
        <span class="addional">{{ $t('bootcampDetail.targetAudience.title') }}</span>
        <h5 class="title font-poppins" style="font-family: 'Poppins', sans-serif !important">
            {{ $t('bootcampDetail.targetAudience.subtitle') }}
        </h5>
        <div class="card-audiance-target mt-5">
            <div v-for="(i, targetParticipant) in targetParticipants" :key="targetParticipant" class="target-participant-child">
                <img :src="$utils.loadImage(i.icon)" style="border-radius: 6px;" alt="ENG" width="40" height="40" />
                <h3 class="mt-3">{{ i.title }}</h3>
                <p style="font-size: 12px;color: rgba(87, 89, 102, 1);">{{ i.desc }}</p>
            </div>
        </div>
      </div>

      <div class="container">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500;">{{
          $t('bootcampDetail.instructorSection.title') }}</span>
        <h5 class="title"
          style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px; line-height: 28px;">
          {{ $t('bootcampDetail.instructorSection.subtitle') }}</h5>
        <div class="mentor-card d-flex mt-5" v-for="(data, idx) in instructor" :key="idx">
            <div class="d-flex">
            <img :src="$utils.loadImage(data.image_url)" alt=""
                style="width: 30%; border-radius: 8px 0 0 8px;object-fit: cover;" />
                <div class="pa-5">
                <div class="mb-3"><span class="bold">{{ data.name }}</span></div>
                <p style="font-size: 14px;">{{ data.description.slice(0, 100) }}</p>
                </div>
            </div>
        </div>
      </div>

      <div class="container">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500; line-height: 28px;">{{
          $t('bootcampDetail.sections.whyHiColleagues.title') }}</span>
        <h5 class="title"
          style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px; margin-bottom: 32px;">
          {{ $t('bootcampDetail.sections.whyHiColleagues.subtitle') }} </h5>
        
        <div class="card-why-hicolleagues">
            <div class="why-hicolleagues-child" v-for="(item, idx) in $t('bootcampDetail.whyHiColl')" :key="idx">
                <div class="circle-yellow">
                   <img :src="item.img" width="24" alt="Ctn" />
                </div>
                <h3 class="mt-3">{{ item.title }}</h3>
                <p style="color: rgba(87, 89, 102, 1);font-size: 13px;">{{ item.desc }}</p>

                <div v-if="item.key === 'certification'" class="d-flex align-center">
                  <img src="/img/bootcamp/aca.png" alt="" style="width: 64px;">
                  <span class="ml-3" style="font-weight: 600;">Alibaba Cloud Associate (ACA) Developer</span>
                </div>
            </div>
        </div>
      </div>

      <div class="container">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500;">{{
          $t('bootcampDetail.scheduleSection.title') }}</span>
        <h5 class="title"
          style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px; margin-bottom: 32px; line-height: 28px;">
          {{ $t('bootcampDetail.scheduleSection.subtitle') }}</h5>

        <div class="timeline-bootcamp mt-5 pa-5" v-for="(item, idx) in classDetail.schedules" :key="idx">
            <div>
                <div class="d-flex align-center" style="height: 50px;">
                    <p class="batch mr-3">Batch {{ item.batch_number }}</p>
                    <div class="d-flex justify-space-between align-center label-quota">
                    <div class="pt-1"><img src="/img/bootcamp/ic_verified.png" alt="" style="width: 16px;"></div>
                    <span>Kuota Tersedia</span>
                    </div>
                </div>
                <span class="bold">{{ formatDate(item.start_date) }} - <span class="bold">{{ formatDate(item.end_date) }}</span><br></span><br>
            </div>
            <div class="info-schadule">
                <div class="d-flex mb-3">
                    <div class="mr-10">
                        <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.totalDuration') }}</span><br>
                        <span class="bold">{{
                        $utils.getMonthDifference(item.start_date, item.end_date) }}</span>
                    </div>
                    <div>
                        <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.totalSession') }}</span> <br>
                        <span class="bold">{{ item.session }} {{$t('bootcampDetail.scheduleSection.labels.session') }}</span>
                    </div>
                </div>
                <div>
                    <span class="sm">{{ $t('bootcampDetail.scheduleSection.labels.classSchedule') }}</span><br>
                    <span class="bold">{{ classDetail.days }}, {{ classDetail.hours }}</span>
                </div>
            </div>

            <v-divider class="mt-5"></v-divider>
            <div style="text-align: left;" class="mt-5">
                <span style="font-size: 14px;font-weight: 600;color: #36373F;">Harga Spesial Promo</span>
                <div class="d-flex align-center mt-3">
                    <span style="color: #7B7E8C; text-decoration: line-through;font-size: 16px;font-weight: 400;">{{ 40000000 | toCurrency }}</span>
                    <div class="label-discount ml-3">Hemat 40%</div>
                </div>
                <h3 style="color: #162CA2;font-size: 22px;"> {{ classDetail.price | toCurrency }}</h3>
            </div>

            <div style="gap: 18px;" class="mt-5 mb-6">
                <v-btn depressed color="#162CA2" @click="goToCheckoutPage('register')" class="box-cta-daftar">
                <span class="text-capitalize white--text"
                    style="font-size: 14px; letter-spacing: 0 !important;font-weight: 600;">
                    {{ $t('bootcampDetail.scheduleSection.ctaButtons.registerNow') }}
                </span>
                </v-btn>
            </div>
        </div>
      </div>
      <!-- <div class="container">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500;">{{
          $t('bootcampDetail.paymentMethodSection.title') }}</span>
        <h5 class="title"
          style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px; margin-bottom: 32px; line-height: 28px;">
          {{ $t('bootcampDetail.paymentMethodSection.subtitle') }}</h5>
        <div class="cada-parent">
          <div v-for="(data, idx) in $t('bootcampDetail.paymenMethod')" :key="idx" class="card-sayhay">
            <components :is="data.icon" style="width: 40px;"></components>
            <h3>{{ data.title }}</h3>
            <p style="font-size: 14px" class="mt-4">{{ data.desc }}</p>
          </div>
        </div> -->
      <!-- </div> -->
       
      <div class="container">
        <span class="font-poppins" style="font-size: 16px; color: #575966; font-weight: 500;">
          {{ $t('publicTrainingDetail.faqSection.subtitle') }}</span>
        <h5 class="title" style="font-family: 'Poppins', sans-serif !important; color: #36373F; font-weight: 700; font-size: 20px; margin-bottom: 32px; line-height: 28px;">
          {{ $t('bootcampDetail.a1') }}</h5>

        <div v-for="(item, index) in questions" :key="index" class="mb-10">
            <AccordeonFaq :title="item.title" :description="item.description" :active="item.active" @toggle="toggleAccordionFaq(index)" />
            <v-divider></v-divider>
        </div>
        
        <div class="btn-stoke-blue cursor-pointer" @click="goToFaqPage"
            style="margin: 0; padding: 10px 25px; gap: 10px; background-color: white">
            <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
            <ArrowLong />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import Popup from "@/components/others/Popup.vue";
// import ArrowLong from '@/assets/icons/ArrowLong.vue';
import AccordeonFaq from '@/components/AccordeonFaq.vue';

export default {
  name: 'DetailClassBootcampMobile',
  components: {
    // ArrowLong,
    Popup,
    AccordeonFaq
  },
  data() {
    return {
        curriculumActive: 1,
      tempCurriculums: {
        id: 1, title: 'Fundamental Programming & Pengenalan Ekosistem', desc: 'Anda akan membangun fondasi yang kokoh dalam <b>logika pemrograman universal</b> sebelum menyelami bahasa spesifik. Serta memahami cara kerja algoritma, struktur data dasar, dan alur kontrol. Sehingga dalam fase ini anda mampu membuat program Go CLI sederhana, dan aplikasi Vue.js frontend dasar.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Pengenalan dasar bahasa Go, sintaks, tipe data, dan kontrol aliran. Anda akan membuat aplikasi Command Line Interface (CLI) sederhana.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Mempelajari dasar-dasar Vue.js untuk membangun antarmuka pengguna interaktif, termasuk konsep komponen, data binding, dan event handling. Anda akan membuat aplikasi frontend sederhana (tanpa backend).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan <b>komunikasi efektif</b>, memahami <b>etika profesional</b>, dan menumbuhkan <b>growth mindset</b> untuk pembelajaran berkelanjutan.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_vuejs.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_html.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_css.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_js.png'},
          ]
      },
      curriculums: [
        {
          id: 1, title: 'Fundamental Programming & Pengenalan Ekosistem', desc: 'Anda akan membangun fondasi yang kokoh dalam <b>logika pemrograman universal</b> sebelum menyelami bahasa spesifik. Serta memahami cara kerja algoritma, struktur data dasar, dan alur kontrol. Sehingga dalam fase ini anda mampu membuat program Go CLI sederhana, dan aplikasi Vue.js frontend dasar.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Pengenalan dasar bahasa Go, sintaks, tipe data, dan kontrol aliran. Anda akan membuat aplikasi Command Line Interface (CLI) sederhana.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Mempelajari dasar-dasar Vue.js untuk membangun antarmuka pengguna interaktif, termasuk konsep komponen, data binding, dan event handling. Anda akan membuat aplikasi frontend sederhana (tanpa backend).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan <b>komunikasi efektif</b>, memahami <b>etika profesional</b>, dan menumbuhkan <b>growth mindset</b> untuk pembelajaran berkelanjutan.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_vuejs.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_html.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_css.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_js.png'},
          ]
        },
        {
          id: 2, title: 'Pengembangan Core & Interaksi', desc: 'Anda akan membangun aplikasi yang saling terhubung antara backend dan frontend. Sehingga dalam fase ini anda mampu membuat RESTful API Go yang terhubung database, dan aplikasi Vue.js frontend yang berinteraksi dengan API tersebut secara dinamis.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Mempelajari cara membangun <b>RESTful API</b> menggunakan Go, termasuk routing, penanganan request/response, dan <b>integrasi database SQL</b> untuk operasi CRUD (Create, Read, Update, Delete). Anda akan membuat backend API yang berfungsi penuh.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Menguasai <b>manajemen state</b> aplikasi dengan Vuex/Pinia dan <b>routing</b> menggunakan Vue Router untuk membuat Single Page Application (SPA). Anda juga akan belajar cara berinteraksi dengan API yang sudah dibuat (mengambil, mengirim, mengedit, menghapus data).'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengasah kemampuan <b>kolaborasi tim</b> melalui penggunaan Git dan prinsip Agile dasar, serta meningkatkan skill <b>pemecahan masalah</b> dan debugging.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_github.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_postgres.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_postman.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        },
        {
          id: 3, title: 'Optimasi, Skalabilitas, & Profesionalisme', desc: 'Anda akan meningkatkan kualitas, performa, dan keamanan aplikasi, serta merancang arsitektur yang lebih baik. Dalam fase ini, Anda tidak hanya akan mengoptimalkan aplikasi yang sudah ada, tetapi juga mulai mengintegrasikan kecerdasan buatan. Anda akan belajar bagaimana membangun Aplikasi Go API yang teruji, aman dengan autentikasi, dan aplikasi Vue.js yang canggih dan responsif, siap untuk tahapan deployment, serta mampu mengintegrasikan fitur AI.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'Go', desc: 'Mendalami <b>arsitektur aplikasi</b> (layered architecture), <b>pengujian (Unit Testing)</b> yang komprehensif, konsep <b>concurrency (Goroutines & Channels)</b> untuk aplikasi yang lebih efisien, dan implementasi <b>autentikasi (JWT)</b>.'
                  },
                  {
                    id: 2, title: 'Vue.js', desc: 'Membangun komponen lanjutan yang reusable, mengelola state yang kompleks, pengujian frontend (Unit Testing), dan optimasi performa aplikasi Vue.js. Anda juga akan mengenal penggunaan <b>UI Frameworks.</b>'
                  },
                  {
                    id: 3, title: 'Integrasi AI', desc: 'Anda akan mempelajari dasar-dasar <b>integrasi OpenAI API</b> untuk menambahkan fitur kecerdasan buatan ke aplikasi And'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Mengembangkan kemampuan <b>presentasi efektif, manajemen waktu dan prioritas</b>, serta dasar-dasar <b>pengambilan keputusan dan personal branding</b>.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_jwt.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_newrelic.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_openai.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 5, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        },
        {
          id: 4, title: 'Proyek Akhir & Persiapan Karir (dengan Integrasi ACA)', desc: 'Anda akan menerapkan semua pengetahuan dalam <b>proyek full-stack end-to-end, mendeploy ke Alibaba Cloud</b>, dan mempersiapkan diri untuk karir profesional. Sehingga dalam fase ini anda dapat membangun Proyek full-stack mandiri yang ter-deploy di Alibaba Cloud, portofolio kerja yang kuat, pemahaman cloud computing yang solid, dan kesiapan penuh untuk memasuki dunia kerja sebagai Full-Stack Developer bersertifikasi.',
          material: {
            categories: [
              {
                id: 1, type: 'Hard Skill',
                detail: [
                  {
                    id: 1, title: 'All Stack', desc: 'Anda akan merencanakan, mengembangkan, dan mendeploy sebuah aplikasi full-stack yang kompleks, mengintegrasikan semua skill Go dan Vue.js yang telah dipelajari.'
                  },
                  {
                    id: 2, title: 'Alibaba Cloud Associate (ACA)', desc: 'Mempelajari konsep cloud computing fundamental dan layanan utama Alibaba Cloud (ECS, RDS, OSS, VPC, dll.) yang relevan untuk deployment aplikasi. Pengetahuan ini akan langsung diaplikasikan dalam proses deployment proyek akhir Anda ke Alibaba Cloud. Anda akan dipersiapkan untuk ujian sertifikasi ACA.'
                  },
                ]
              },
              {
                id: 2, type: 'Soft Skill',
                detail: [
                  {
                    id: 1, title: '', desc: 'Membuat <b>portofolio digital</b> yang menarik dan memahami strategi <b>pengembangan karir</b> jangka panjang.'
                  }
                ]
              }
            ],
          },
          tools: [
            {id: 1, img: '/img/bootcamp/tools/ic_alicloud.png'},
            {id: 2, img: '/img/bootcamp/tools/ic_docker.png'},
            {id: 3, img: '/img/bootcamp/tools/ic_go.png'},
            {id: 4, img: '/img/bootcamp/tools/ic_vuejs.png'},
          ]
        }
      ],
      targetParticipants: [
        {
          id: 1, icon: '/img/bootcamp/ic_graduate.png', title: 'Fresh Graduate', desc: 'Mempersiapkan skill untuk masuk dalam dunia kerja nyata & raih karir impian dengan bimbingan intensif.'
        },
        {
          id: 2, icon: '/img/bootcamp/ic_junior_coder.png', title: 'Junior Developers', desc: 'Upgrade skill dari ngoding ke building agar bisa segera naik jabatan dan penghasilan.'
        },
        {
          id: 3, icon: '/img/bootcamp/ic_career_switch.png', title: 'Career Switchers', desc: 'Mulai perjalanan karir baru sesuai minat & passion-mu, tanpa pengalaman sebelumnya.'
        },
      ],
      methodePembayaran: [
        {
          title: 'Pembayaran Pertama',
          type: '(Saat Pendaftaran)',
          list: [
            '<span>Ketika calon peserta mendaftar untuk bootcamp, calon peserta akan diminta untuk</span> membayar pembayaran pertama.',
            '<span>Besaran</span> pembayaran pertama adalah 1/3 dari total harga bootcamp, <span>yaitu sebesar Rp. 2.500.000.</span>',
            '<span>Calon peserta akan dianggap</span> resmi terdaftar setelah pembayaran pertama diterima',
          ],
        },
        {
          title: 'Pembayaran Kedua',
          type: '(Tengah Training / Senin, 13 November 2023)',
          list: [
            'Pembayaran kedua akan jatuh tempo pada tengah periode pelatihan, <span>yaitu pada tanggal yang telah ditentukan dalam perjanjian pendaftaran.</span>',
            '<span>Besaran</span> pembayaran kedua juga adalah 1/3 dari total harga bootcamp, <span>yaitu sebesar Rp. 2.500.000.</span>',
            '<span>Peserta akan</span> diingatkan sebelum jatuh tempo <span>pembayaran kedua</span>',
          ],
        },
        {
          title: 'Pembayaran Ketiga',
          type: '(Sebelum Penerimaan Sertifikat)',
          list: [
            '<span>Pembayaran ketiga akan dilakukan setelah calon peserta</span> menyelesaikan seluruh pelatihan dan memenuhi semua persyaratan <span>yang diperlukan.</span>',
            'Pembayaran ketiga adalah sisa dari total harga bootcamp, <span>yaitu sebesar Rp. 2.500.000.</span>',
            '<span>Peserta akan diingatkan</span> sebelum jatuh tempo <span>pembayaran ketiga.</span>',
            '<span>Setelah pembayaran ketiga diterima, peserta akan diberikan</span> sertifikat sebagai bukti kelulusan.',
          ],
        },
      ],
      priceAddInfo: ['Tipe kelas Public', 'Kapasitas max 10 peserta', 'Jadwal kelas telah ditentukan', 'Diajarkan langsung oleh mentor', 'Gratis Survival Kit', 'Sertifikat Kelulusan'],
      classDetail: {
        schedules: []
      },
      isAlertErr: false,
      isRegistrantClose: false,
      alertErrMessage: "",
      expired: [],
      instructor: [],
      questions: [],
      layout: 'info-kelas',
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getFaq();
      this.getDetailClass();
    },
  },
  methods: {
    getCurriculum(cur) {
      this.tempCurriculums = this.curriculums[cur];
      this.curriculumActive = cur+1;
    },
    toggleAccordion(index) {
      this.classDetail.summary_syllabus[index].show = !this.classDetail.summary_syllabus[index].show;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Syllabus - ${this.classDetail.summary_syllabus[index].name} - Bootcamp Detail Page`,
        value: 1,
      });
    },
    toggleAccordionFaq(index) {
      this.questions[index].active = !this.questions[index].active;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.questions[index].title} - Bootcamp Detail Page`,
        value: 1,
      });
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Free Consultation WhatsApp - ${this.classDetail.name} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open('https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya', '_blank');
    },
    goToCheckoutPage(i) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Register Now - ${this.classDetail.name} - Bootcamp Detail Page`,
        value: 1,
      });
      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.is_discount ? this.classDetail.price - this.classDetail.discount_price : this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: 'BOOTCAMP_CLASS',
        methode: this.classDetail.method,
        days: this.classDetail.days,
        schedule: this.classDetail.schedules,
        category_id: this.classDetail.category_id,
      });
      localStorage.clear();
      localStorage.setItem('checkout', req);
      window.location.href = `/checkout/bootcamp?category=BOOTCAMP&slug_name=${this.$route.params.slug_name}&p=${i}`;
    },
    toDiscount(total_price) {
      if (total_price <= 0) {
        return "FREE";
      } else {
        var formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Free Consultation WhatsApp - ${this.classDetail.name} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open('https://api.whatsapp.com/send/?phone=6282127274632&text=Hi Kak HiColleagues, saya mau bertanya', '_blank');
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === "online") {
        return "Daring (via Zoom)";
      } else if (value.toLowerCase() === "offline") {
        return "Luring";
      } else {
        return value;
      }
    },
    toLink(link, batchNumber) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Offline Webinar Location - Batch ${batchNumber} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open(link, '_blank');
    },
    formatDateInfo(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    openFaq(idx) {
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle FAQ - ${this.questions[idx].title} - Bootcamp Detail Page`,
        value: 1,
      });
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=DETAIL_CLASS&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.error(err);
      }
    },
    countDownTimer() {
      const _second = 1000;
      const _minute = _second * 60;
      const _hour = _minute * 60;
      const _day = _hour * 24;
      let timer;
      let days, hours, minutes, seconds;
      const showRemaining = () => {
        const end = new Date(this.classDetail.end_discount_date);
        const now = new Date();
        const distance = end - now;
        if (distance < 0) {
          clearInterval(timer);
          this.expired = [];
          return;
        }
        days = Math.floor(distance / _day);
        hours = Math.floor((distance % _day) / _hour);
        minutes = Math.floor((distance % _hour) / _minute);
        seconds = Math.floor((distance % _minute) / _second);
        this.expired = [days, hours, minutes, seconds];
      };
      timer = setInterval(showRemaining, 1000);
    },
    async getDetailClass() {
      try {
        const response = await this.$http.get(`/v1/class-detail/${this.$route.params.slug_name}`);
        const data = response.data.data.class_detail;
        this.classDetail = {
          ...data,
          summary_syllabus: data.summary_syllabus
            ? data.summary_syllabus.map((item) => ({
              ...item,
              show: true,
            }))
            : [],
        };
        this.instructor = [
          response.data.data.instructor
        ];
        this.countDownTimer();
        this.isRegistrantClose = new Date(this.classDetail.registration_close_date) <= new Date();
      } catch (error) {
        this.$router.push('/class/bootcamp');
      }
    },
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY');
    },
    redirectToLinkedIn(url, instructorName) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Instructor LinkedIn - ${instructorName} - Bootcamp Detail Page`,
        value: 1,
      });
      window.open(url, '_blank');
    },
    goToFaqPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Bootcamp Detail Page',
        value: 1,
      });
      this.$router.push('/faq');
    },
  },
  mounted() {
    this.getDetailClass();
    window.scrollTo(0, 0);
    this.getFaq();
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style src="./DetailBootcamp.css" scoped></style>